export const MANAGE_POLICY_PRIVILEGES = {
  endorsements: {
    add: "managePolicy.endorsements.management.add",
    view: "managePolicy.endorsements.management.view",
    edit: "managePolicy.endorsements.management.edit",
    downloadCopy: "managePolicy.endorsements.management.downloadCopy",
    share: "managePolicy.endorsements.management.share",
    delete: "managePolicy.endorsements.management.delete"
  },
  claims: {
    add: "managePolicy.claims.management.add",
    export: "managePolicy.claims.management.export"
  },
  renewals: {
    process: "managePolicy.renewals.processing.process"
  }
};

export const endorsementAccessPrivileges = Object.values(MANAGE_POLICY_PRIVILEGES.endorsements);
export const claimAccessPrivileges = Object.values(MANAGE_POLICY_PRIVILEGES.claims);
